import { mergeStyles } from '@fluentui/react';
import { IPLayerHost } from 'baseComponents';
import { globalLayerHostSceneId } from 'globalStyles';

// Host for content that should fill the scene area (e.g. the pinned Copilot preview). It sits inside the
// scene grow-container (which is position: relative), so an absolutely positioned layer covers exactly the
// scene region and leaves the docked Copilot chat and the right-side panels untouched. zIndex stays below
// the right-side bar (800) and notification (900) hosts so those still overlay when open.
const layerHostClassScene = mergeStyles({
  position: 'absolute',
  inset: 0,
  overflow: 'hidden',
  pointerEvents: 'none',
  zIndex: 1,

  selectors: {
    '& > *': {
      pointerEvents: 'auto',
    },
  },
});

export default function AppSceneLayerHost() {
  return <IPLayerHost id={globalLayerHostSceneId} className={layerHostClassScene}></IPLayerHost>;
}
